import React from 'react'




//Function To show sub components
function LoaderSubComponent({ component }) {
    //const { breakPoint } = useViewport();
    const [loading, setLoading] = React.useState(true);
    //Simulate loading data 
    React.useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    if (loading) {
        return (
            <>
                <div className="center">

                    <div className="loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <div className='loader-text'>Loading ...</div>
                </div>
            </>
        )
    }
    return (
        <>
            {/*{breakPoint === 'xs' ? <div>SM OPTION</div> : component}*/}
            {component}
        </>
    );
}

export default LoaderSubComponent;







